import React from 'react';
import { remotePaths, routeMap } from 'router/routes';
import ContactInfo from '../../containers/ContactInfoContainer';
import HistoryContainer from '../../containers/HistoryContainer';
import PersonalData from '../../containers/PersonalDataContainer';
import SignContainer from '../../containers/SignContainer';
import AccountsAbroadContainer from '../../containers/AccountsAbroadContainer';
import ParticipationInOrganizations from '../ParticipationInOrganizations';
import PaymentInformation from 'modules/Profile/containers/PaymentInformationContainer';
import BankAccountsContainer from 'modules/Profile/containers/BankAccountsContainer';
import FamilyAccess from 'modules/Profile/components/FamilyAccess';
import InvestAccounts from 'modules/Profile/components/InvestAccounts';
import { unitTypes } from '../../../NewTaxes/redux/hasUnits/unitTypes';

export const PROFILE_TABS = [
  {
    id: 'profile',
    tabName: 'Контактная информация',
    tabComponent: <ContactInfo />,
    tabRoute: remotePaths.profile,
    active: true,
  },
  {
    id: 'profilePersonalData',
    tabName: 'Персональные данные',
    tabComponent: <PersonalData />,
    tabRoute: remotePaths.profile,
    active: true,
  },
  {
    id: 'paymentInfo',
    tabName: 'Платежная информация',
    tabComponent: <PaymentInformation />,
    tabRoute: routeMap.paymentInfo,
    active: true,
  },
  {
    id: 'participationInOrganizations',
    tabName: 'Участие в организациях',
    tabComponent: <ParticipationInOrganizations />,
    tabRoute: remotePaths.participationInOrganizations,
    active: true,
  },
  {
    id: 'profileActivityHistory',
    tabName: 'История действий',
    tabComponent: <HistoryContainer />,
    tabRoute: remotePaths.profileActivityHistory,
    active: true,
  },
  {
    id: 'profileSign',
    tabName: 'Получить ЭП',
    tabComponent: <SignContainer />,
    tabRoute: remotePaths.profileSign,
    active: true,
  },
  {
    id: 'profileInvestAccounts',
    tabName: 'Сведения об ИИС',
    tabComponent: <InvestAccounts />,
    tabRoute: routeMap.profileInvestAccounts,
    active: true,
    unitType: unitTypes.INVEST_ACCOUNT_DATA,
  },
  {
    id: 'profileAccounts',
    tabName: 'Сведения о банковских счетах',
    tabComponent: <BankAccountsContainer />,
    tabRoute: remotePaths.profileAccounts,
    active: true,
  },
  {
    id: 'profileAccountsAbroad',
    tabName: 'Счета за рубежом',
    tabComponent: <AccountsAbroadContainer />,
    tabRoute: remotePaths.profileAccountsAbroad,
    active: true,
  },
  {
    id: 'familyAccess',
    tabName: 'Семейный доступ',
    tabComponent: <FamilyAccess />,
    tabRoute: remotePaths.profileFamilyAccess,
    active: ({ user: { familyAccess } }) => {
      return familyAccess;
    },
  },
];

export const profileTabsRoutes = PROFILE_TABS.map(({ tabRoute }) => tabRoute);
